import { Coordinate } from "game-common/models"

/**
 * The non-visual half of a charged shot: sound and camera kick.
 *
 * The thing that knows WHEN each moment happens is the projectile's renderable -- it is the only
 * object watching the server's phase field frame by frame. The things that can act on it are the
 * Audio instance and the camera, both of which hang off ClientGameLogic. A renderable reaching for
 * ClientGameLogic would close an import cycle (logic -> renderer -> sprites -> logic), so the two
 * halves meet here instead: ClientGameLogic installs a sink, the renderable calls through it, and
 * neither imports the other.
 *
 * Nothing is installed in the unit-test harness, so every call is a no-op there unless a test
 * installs its own sink -- which is also how the phase-trigger logic is tested without pixi-sound.
 */
export interface EmberCoreFeedback {
    /** A charge has just been thrown, at the shooter's muzzle. */
    fired: (at: Coordinate) => void
    /** It has hit the ground and the fuse has started burning. */
    landed: (at: Coordinate) => void
    /** It has gone off. Sound AND the camera kick, both scaled by distance to the listener. */
    detonated: (at: Coordinate) => void
}

let installed: EmberCoreFeedback | undefined

export const installEmberCoreFeedback = (feedback?: EmberCoreFeedback) => {
    installed = feedback
}

export const emberCoreFeedback: EmberCoreFeedback = {
    fired: at => installed?.fired(at),
    landed: at => installed?.landed(at),
    detonated: at => installed?.detonated(at),
}
